// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Router from "next/router";
import * as UrlUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/UrlUtils.mjs";
import * as NextImage$PorterinFeature from "../../../../ui/components/NextImage.mjs";
import * as CityContext$PorterinFeature from "../../../../contexts/city-context/CityContext.mjs";
import * as CountryHelpers$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/helpers/CountryHelpers.mjs";
import * as GAEventsConstants$PorterinFeature from "../../../core/constants/GAEventsConstants.mjs";
import * as PublishEventsHelper$PorterinFeature from "../../../core/helpers/PublishEventsHelper.mjs";
import * as DownloadAnalyticsHelper$PorterinFeature from "../../../../containers/download-app/helpers/DownloadAnalyticsHelper.mjs";

function FooterDownloadAppCmp(Props) {
  var styles = Props.styles;
  var isDesktop = Props.isDesktop;
  var footer_data = Props.footer_data;
  var match = CityContext$PorterinFeature.useCitySelectedContext(undefined);
  var category = match.category;
  var match$1 = CityContext$PorterinFeature.useCitySelectedContext(undefined);
  var city_selected = match$1.city_selected;
  var match$2 = Router.useRouter();
  var locale = match$2.locale;
  var router = Router.useRouter();
  var downloadLink = DownloadAnalyticsHelper$PorterinFeature.getAppDownloadLinkFooter(UrlUtils$Catalyst.getURLParams(router.asPath), city_selected, isDesktop, router.pathname);
  return React.createElement("div", {
              className: styles.download
            }, React.createElement("div", {
                  className: styles["qr-image"]
                }, React.createElement(NextImage$PorterinFeature.make, {
                      src: Belt_Option.mapWithDefault(footer_data, "/assets/download-qr-code.png", (function (data) {
                              return data.download_app_qr.path;
                            })),
                      height: 146.0,
                      width: 146.0,
                      quality: 75.0,
                      alt: "qr-download"
                    })), React.createElement("div", {
                  className: styles["download-android"],
                  onClick: (function (param) {
                      PublishEventsHelper$PorterinFeature.publishEvents(category, GAEventsConstants$PorterinFeature.gaFooterPlaystore + CountryHelpers$PorterinUtils.countryCodeFromLocaleForGa(locale), city_selected);
                    })
                }, React.createElement("a", {
                      href: downloadLink
                    }, React.createElement(NextImage$PorterinFeature.make, {
                          src: Belt_Option.mapWithDefault(footer_data, "/assets/googleplay.png", (function (data) {
                                  return data.play_store_icon.path;
                                })),
                          height: isDesktop ? 39.0 : 48.0,
                          width: isDesktop ? 126.0 : 158.0,
                          quality: 75.0,
                          alt: "android-download"
                        }))), React.createElement("div", {
                  className: styles["download-iOS"],
                  onClick: (function (param) {
                      PublishEventsHelper$PorterinFeature.publishEvents(category, GAEventsConstants$PorterinFeature.gaFooterAppstore + CountryHelpers$PorterinUtils.countryCodeFromLocaleForGa(locale), city_selected);
                    })
                }, React.createElement("a", {
                      href: downloadLink
                    }, React.createElement(NextImage$PorterinFeature.make, {
                          src: Belt_Option.mapWithDefault(footer_data, "/assets/appstore.png", (function (data) {
                                  return data.app_store_icon.path;
                                })),
                          height: isDesktop ? 39.0 : 48.0,
                          width: isDesktop ? 126.0 : 158.0,
                          quality: 75.0,
                          alt: "iOS-download"
                        }))));
}

var Link;

var make = FooterDownloadAppCmp;

export {
  Link ,
  make ,
}
/* react Not a pure module */
